// @ts-nocheck

import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import { T } from '@/v2/helpers/i18n';
import { TicketDescription } from '@ticketmaster/global-design-system';

type Props = {} & T;

const BarcodeNotYetActive = ({ t }: Props) => {
  return (
    <TicketDescription>
      <TicketDescription.Header icon="info">
        <TicketDescription.Title>{t('WALLET.TICKETS.BARCODE_NOT_YET_ACTIVE')}</TicketDescription.Title>
        <TicketDescription.Description>{t('WALLET.TICKETS.BARCODE_WILL_DISPLAY_BEFORE_THE_EVENT')}</TicketDescription.Description>
      </TicketDescription.Header>
    </TicketDescription>
  );
};

export default withTranslation('translation')(memo(BarcodeNotYetActive));
